import React from 'react';
import {Typography} from '~library/atoms/Typography';
import {Button} from '~library/atoms/Button';
import {useImageFlip} from '~/CreateFabricInvitation/components/PhotoEditor/common/useImageFlip';
import {ReflectHorizontalIcon} from '~library/svg/ReflectHorizontalIcon';
import {ReflectVerticalIcon} from '~library/svg/ReflectVerticalIcon';
import './FlipControl.sass';

export const FlipControl = ({canvas}) => {
  const {handleFlipX, handleFlipY} = useImageFlip(canvas);

  return (
    <div className="flip-buttons">
      <Button
        variant="unstyled-button"
        className="flip-button flip-horizontal"
        onClick={handleFlipX}
        data-qa-id="flip-horizontal-btn"
      >
        <ReflectHorizontalIcon />
        <Typography variant="label2">Flip Horizontal</Typography>
      </Button>
      <Button
        variant="unstyled-button"
        className="flip-button flip-vertical"
        onClick={handleFlipY}
        data-qa-id="flip-vertical-btn"
      >
        <ReflectVerticalIcon />
        <Typography variant="label2">Flip Vertical</Typography>
      </Button>
    </div>
  );
};
